import { SERVER_API_URL } from 'app/config/constants';
import { SET_SHOW_ELIGIBILITY_MODAL } from 'app/modules/step-engine/service/store/step-engine-actions';
import { ELEGIBILITY_SUBSCRIPTION_CANCEL_BTN_PRISMIC_ATTRIBUTE, ELEGIBILITY_SUBSCRIPTION_MSG_PRISMIC, ELIGIBILITY_EXCEPTION_TYPE } from 'app/shared/constants/constants';
import { ACTION_TYPES } from 'app/shared/reducers/kubrick-management';
import axios from 'axios';
import { store } from '../index';
const TIMEOUT = 1 * 60 * 1000;
axios.defaults.timeout = TIMEOUT;
axios.defaults.baseURL = SERVER_API_URL;

const blockUserWhenEligibilityException = () => {
  store.dispatch({
    type: SET_SHOW_ELIGIBILITY_MODAL,
    payload: true,
  });
  store.dispatch({
    type: ACTION_TYPES.SET_MODAL_MSG,
    payload: ELEGIBILITY_SUBSCRIPTION_MSG_PRISMIC,
  });
  store.dispatch({
    type: ACTION_TYPES.SET_MODAL_CANCEL_BTN,
    payload: ELEGIBILITY_SUBSCRIPTION_CANCEL_BTN_PRISMIC_ATTRIBUTE,
  });
}

const setupAxiosInterceptors = onUnauthenticated => {
  const onRequestSuccess = config => {
    return config;
  };
  const onResponseSuccess = response => response;
  const onResponseError = err => {

    const status = err.status || (err.response ? err.response.status : 0);
    if (status === 403) {
      switch (err.response.data.type) {
        case ELIGIBILITY_EXCEPTION_TYPE: {
          blockUserWhenEligibilityException(); break;
        }
        default: break;
      }
    }

    if (status === 401) {
      onUnauthenticated();
    }
    return Promise.reject(err);
  };


  axios.interceptors.request.use(onRequestSuccess);
  axios.interceptors.response.use(onResponseSuccess, onResponseError);
};



export default setupAxiosInterceptors;
